<template>
  <loading class="loading" v-if="isLoading"></loading>
  <div v-else class="request-detail">
    <app-title :title="request.name"></app-title>
    <div class="request-main">
      <div class="preview-box">
        <div class="preview" v-if="request.img1" :style="`background-image: url(${requestPreview})`" @click="previewModal=true, modalImg=requestPreview">
          <div v-if="request.is_done==1" class="sold">sold</div>
        <!-- <div class="preview" v-else :style="[background-image: url(request.img1)]"> -->
        </div>
        <div class="sub-preview-wrapper">
          <div class="sub-preview" v-if="request.img1" @click="requestPreview = request.img1" :style="`background-image: url(${request.img1})`">
            <!-- <img :src="request.img1"> -->
          </div>
          <div class="sub-preview" v-if="request.img2" @click="requestPreview = request.img2" :style="`background-image: url(${request.img2})`">
            <!-- <img :src="request.img2"> -->
          </div>
          <div class="sub-preview" v-if="request.img3" @click="requestPreview = request.img3" :style="`background-image: url(${request.img3})`">
            <!-- <img :src="request.img3"> -->
          </div>
          <div class="sub-preview" v-if="request.img4" @click="requestPreview = request.img4" :style="`background-image: url(${request.img4})`">
            <!-- <img :src="request.img4"> -->
          </div>
          <div class="sub-preview" v-if="request.img5" @click="requestPreview = request.img5" :style="`background-image: url(${request.img5})`">
            <!-- <img :src="request.img5"> -->
          </div>
        </div>
      </div>

      <div class="share-button sp">
        <div class="twitter-share-button" @click="tweet(request.name)">
          <img src="../../assets/img/tweetBtn.png">
        </div>
      </div>

      <div class="request-info">
        <div class="request-info-item">
          <h1 class="request-title mb-30">{{ request.name }}</h1>
        </div>

        <div class="request-info-item">
          <p class="request-price">¥{{ request.price }} <span v-if="request.tips"> + {{lang[5]}}({{request.tips}})</span></p>
          <div class="delivery-and-state">
            <!-- <p class="gray-tag">{{ request.delivery_service }}
              <span v-if="request.is_fee">{{lang[8]}}</span>
              <span v-if="!request.is_fee">{{lang[9]}}</span>
            </p> -->
            <p class="gray-tag">{{ request.state ? lang[24] : lang[23]}}</p>
          </div>
        </div>

        <div class="request-info-item">
          <p class="request-tag-lavel">{{lang[1]}}</p>
          <div v-if="charaName.length>0" class="tag-wrapper">
            <router-link
              v-for="(val, key) in charaName"
              :to="{ path: '/home', query: {c:request.character[key]}}"
            >
              <p class="tag">
                {{val}}
              </p>
            </router-link>
          </div>
          <p v-else>{{request.character}}</p>
        </div>

        <div class="request-info-item">
          <div v-if="isAnime">
            <p class="request-tag-lavel">{{lang[2]}}</p>
            <div class="tag-wrapper">
              <router-link :to="{ path: '/home', query: {t:animeId}}">
                <p class="tag">
                  {{contentTitle}}
                </p>
              </router-link>
            </div>
          </div>
        </div>

        <div class="request-info-item">
          <p class="request-tag-lavel">{{lang[0]}}</p>
          <div v-if="request.tagmaker" class="tag-wrapper">
            <router-link :to="{ path: '/home', query: {m:request.maker}}">
              <p class="tag">
                {{request.tagmaker}}
              </p>
            </router-link>
          </div>
          <p v-else>{{request.maker}}</p>
        </div>

        <div class="request-info-item">
          <span v-if="request.item_category">
            <p class="request-tag-lavel">{{lang[3]}}</p>
            <p class="detail-text">
              <span v-if="request.tagitem_category">{{request.tagitem_category}}</span>
              <span v-else>{{request.item_category}}</span>
            </p>
          </span>
        </div>

      <div class="share-button pc">
        <div class="twitter-share-button" @click="tweet(request.name)">
          <img src="../../assets/img/tweetBtn.png">
        </div>
      </div>

      </div>
    </div>

    <div class="request-wrapper">

      <router-link :to="{ name: 'account.index', params: {name: request.User.name } }">
        <div class="request-user-info">
          <p class="request-user-name">{{lang[12]}}</p>
          <div class="user">
            <div class="icon" v-if="request.User.icon_img" :style="`background-image: url(${request.User.icon_img})`"></div>
            <div class="icon" v-else :style="`background-image: url(${request.User.icon_img}`"></div>
            <div class="user-info">
              <p class="user-id">@{{ request.User.name }}</p>
              <p class="user-name">{{ request.User.screen_name }}</p>
            </div>
          </div>
          <p class="detail-text">{{lang[13]}}: {{request.User.country}}</p>
        </div>
      </router-link>

      <span v-if="request.message">
        <p class="request-message-title">{{lang[11]}}</p>
        <p class="request-message-text">{{ request.message }}</p>
      </span>

      <div v-if="request.Trades[request.Trades.length -1].phase >= 6">
        <p class="request-name">{{lang[14]}}</p>
        <div class="sub-preview-wrapper">
          <div class="sub-preview"
            v-if="decideVal[0].img1"
            @click="previewModal=true,modalImg=decideVal[0].img1">
            <img :src="decideVal[0].img1">
          </div>
          <div class="sub-preview"
            v-if="decideVal[0].img2"
            @click="previewModal=true,modalImg=decideVal[0].img2">
            <img :src="decideVal[0].img2">
          </div>
          <div class="sub-preview"
            v-if="decideVal[0].img3"
            @click="previewModal=true,modalImg=decideVal[0].img3">
            <img :src="decideVal[0].img3">
          </div>
          <div class="sub-preview"
            v-if="decideVal[0].img4"
            @click="previewModal=true,modalImg=decideVal[0].img4">
            <img :src="decideVal[0].img4">
          </div>
          <div class="sub-preview"
            v-if="decideVal[0].img5"
            @click="previewModal=true,modalImg=decideVal[0].img5">
            <img :src="decideVal[0].img5">
          </div>
        </div>
        <p class="detail-title">{{lang[15]}}</p>
        <router-link :to="{ name: 'account.index', params: {name: decideUser.name } }">
          <div class="user">
            <div class="icon" v-if="decideUser.icon_img" :style="`background-image: url(${decideUser.icon_img})`"></div>
            <div class="icon" v-else></div>
            <div class="user-info">
              <p class="user-id">@{{ decideUser.name }}</p>
              <p class="user-name">{{ decideUser.screen_name }}</p>
            </div>
          </div>
        </router-link>
        <p class="detail-title">{{lang[4]}}</p>
        <p class="detail-text">{{ decideVal[0].price }} JPY</p>
        <p class="detail-title">{{lang[10]}}</p>
        <p class="detail-text">{{ decideVal[0].state? lang[24] : lang[23]}}</p>
        <p class="detail-title">{{lang[11]}}</p>
        <p class="detail-text">{{ decideVal[0].message }}</p>
      </div>

      <message :requestData="request"></message>

      <!-- リクエスト側　-->
      <div v-if="request.User.id == $store.state.account.id">

        <!-- トレードがない場合 -->
        <div v-if="request.Trades.length === 0">
        </div>

        <!-- アイデアは送られているけど、まだ決めてない時 RequestPhase0-->
      <div v-else-if="request.Trades[request.Trades.length -1].phase == 0">
          <req-phase0 v-bind:ideas='request.Ideas'></req-phase0>
          <deleteReq v-bind:id="request.id"></deleteReq>
      </div>

      <!-- どれを買うか決めた時 RequestPhase1-->
      <div v-else-if="request.Trades[request.Trades.length -1].phase == 1">
          <req-phase1 v-bind:val='decideVal' v-bind:user='decideUser' v-bind:tips='request.tips'></req-phase1>
          <deleteReq v-bind:id="request.id"></deleteReq>
      </div>

      <!-- 相手の配送待ち -->
      <div v-if="request.Trades[request.Trades.length -1].phase == 4">
        <p class="detail-title">{{lang[16]}}</p>
      </div>


      <!-- 配送された -->
      <div v-if="request.Trades[request.Trades.length -1].phase == 5">
        <req-phase5 :request="request" :decideVal="decideVal[0]" :decideUser="decideUser" :loading="loading" :recieved="recieved" @recieve="recieve"></req-phase5>
      </div>


    </div>


    <!-- 売る側 -->

    <div v-else>
      <div v-if="request.Trades.length == 0 || request.Trades[request.Trades.length -1].phase == 0 && this.$store.state.auth.authenticated">
        <sal-Phase0 v-bind:ideas='request.Ideas'></sal-Phase0>
      </div>
      <div v-else-if="request.Trades.length == 0 || request.Trades[request.Trades.length -1].phase == 0 && !this.$store.state.auth.authenticated">
        <div class="btn-wrapper">
          <btn :label="lang[47]" type="white" size="normal" @click="register('/request/new')"></btn>
          <btn :label="lang[48]" type="primary" size="normal" @click="register($router.path)"></btn>
        </div>
      </div>

      <!-- アイデア決定後 -->

      <div v-if="request.Trades[request.Trades.length -1].phase >= 1 && this.$store.state.auth.authenticated">
        <div v-if="request.Trades[request.Trades.length -1].phase == 1 && this.$store.state.auth.authenticated">
          <sal-Phase1 v-bind:val='decideVal' v-bind:user='decideUser'></sal-Phase1>
        </div>

        <div v-if="request.Trades[request.Trades.length -1].phase == 4 && decideUser.id === $store.state.account.id && this.$store.state.auth.authenticated">
          <sal-Phase4 v-bind:buyerId='request.User.id' v-bind:salerId='decideUser.id'></sal-Phase4>
        </div>

        <modal v-if="confirmShipped" @close="close">
          <p class="text-center detail-title">{{lang[17]}}</p>
          <p class="text-center detail-text">{{lang[18]}}</p>
          <div class="m-t-20 text-center space-around">
            <btn type="cancel" size="normal" :label="lang[41]" @click="close()"></btn>
            <btn type="primary" size="normal" :label="lang[45]" @click="shipped(decideVal[0].id, decideVal[0].saler_id)" :loading="loading"></btn>
          </div>
        </modal>

        <div v-if="request.Trades[request.Trades.length -1].phase == 5 && decideUser.id === $store.state.account.id">
          <sal-Phase5 :buyerId='request.User.id' :salerId='decideUser.id' :requestId="request.id && this.$store.state.auth.authenticated">
          </sal-Phase5>
        </div>
      </div>
      <div v-else-if="request.Trades[request.Trades.length -1].phase >= 1 && !this.$store.state.auth.authenticated">
        <div class="btn-wrapper">
          <btn label="ユーザー登録してリクエストしてみる" type="primary" size="normal" @click="register('/request/new')"></btn>
        </div>
      </div>


      <!-- コンテンツここまで -->

      <modal v-if="isSendIdea" @close="close">
        <p class="request-name text-center">{{lang[19]}}</p>
        <div class="img-area m-t-20">
          <div v-for="val in 5" class="request-img-wrapper">
            <label
              v-if="idea['img'+val]"
              :for="`img${val}`"
              class="request-img"
              :style="`background-image: url(${idea['img'+val]})`">
            </label>
            <label
              v-else
              :for="`img${val}`"
              class="request-img"
              :style="`background-image: url(${cameraImg})`">
            </label>
            <input
              :id="`img${val}`"
              type="file"
              name="file"
              accept="image/*"
              style="dipslay: none;"
              @change="selectedFile"
              >
            </div>
          </div>
          <p class="validate">{{img1Validate}}</p>
          <n-input v-model="idea.price"
            :placeholder="lang[4]"
            type="number"
            @nullCheckVal="nullCheckVal"
            class="m-t-20"
            :validate="priceValidate"
          >
        </n-input>
        <p class="stripe-fee-text">
          {{lang[35]}}: <span v-if="idea.price">{{Math.floor(idea.price - (idea.price * 0.0025) - 450)}}</span>
        </p>
        <p v-if="request.is_fee == 0" style="color: #f3983b;">{{lang[20]}}</p>
        <p v-else>{{lang[21]}}</p>
        <!-- <div class="m-t-20" v-if="request.User.country !== 'Japan'">
          <b>ここを入力すると国際送料の計算が出来ます。</b>
          <n-input v-model="weight" placeholder="重量" type="number" @input="searchShippingFee()">
          </n-input>
          <p>{{ shippingFee}}</p>
        </div> -->
        <div class="select-wrapper">
          <n-select
            v-model="idea.state"
            class="select"
            :placeholder="lang[22]"
            :options="[{label:lang[37], value:'0'}, {label:lang[38], value:'1'}]"
            @nullCheckVal="nullCheckVal"
          >
          </n-select>
          <p class="validate">{{stateValidate}}</p>
        </div>
        <textarea
          v-model="idea.message"
          :placeholder="lang[40]"
          class="m-t-20"
        >
        </textarea>
        <p class="validate">{{messageValidate}}</p>
        <div class="btn-wrapper m-t-20">
          <btn size="normal" type="cancel" :label="lang[41]" @click="close"></btn>
          <btn v-if="!isSend" size="normal" type="cancel" :label="lang[42]"></btn>
          <btn v-else size="normal" type="primary" :label="lang[42]" @click="sendIdea" :loading="loading"></btn>
        </div>
      </modal>
    </div>
  </div>

  <modal v-if="isPurchase" @close="close">
    <div v-if="checkAddress()" class="p-20">
      <p class="request-name text-center">{{lang[25]}}</p>
      <div class="modal-img text-center" :style="`background-image: url(${decideVal[0].img1})`"></div>
      <p class="detail-title p-20 text-center">{{request.name}}</p>
      <p class="detail-title">{{lang[4]}}</p>
      <p class="detail-text">{{ decideVal[0].price }} <span v-if="request.tips"> + {{lang[5]}}({{request.tips}})</span> + {{lang[26]}}</p>
      <p class="detail-title">{{lang[27]}}</p>
      <p class="detail-text">{{ Math.floor((decideVal[0].price + (request.tips ? request.tips:0)) * 1.036)  }}</p>
      <p class="detail-title">{{lang[10]}}</p>
      <p class="detail-text">{{decideVal[0].state? lang[24] : lang[23]}}</p>
      <p class="detail-title">{{lang[28]}}</p>
      <p class="detail-text" v-if="this.$store.state.account.country !== 'Japan'">
        {{$store.state.account.country}},
        {{$store.state.account.post_code}}<br>
        {{$store.state.account.prefecture}},
        {{$store.state.account.address}},
        {{$store.state.account.street}},
        {{$store.state.account.line1}} {{$store.state.account.line2}},
        {{$store.state.account.first_name}} {{$store.state.account.last_name}},
        {{$store.state.account.phone_number}}
      </p>
      <p v-else>
        {{$store.state.account.country}},
        {{$store.state.account.post_code}},<br>
        {{$store.state.account.prefecture_kanji}},
        {{$store.state.account.address_kanji}},
        {{$store.state.account.street_kanji}},<br>
        {{$store.state.account.line1_kanji}} {{$store.state.account.line2_kanji}},<br>
        {{$store.state.account.first_name_kanji}} {{$store.state.account.last_name_kanji}},
        {{$store.state.account.phone_number}}
      </p>
      <div class="btn-wrapper">
        <router-link :to="{ name: 'account.index', params: {name: $store.state.account.name }}" tag="div">
          <btn type="cancel" size="normal" :label="lang[44]" style="margin-right: 20px;"></btn>
        </router-link>
        <btn type="primary" size="normal" :label="lang[39]" @click="isStripeModal=true" :loading="loading"></btn>
      </div>
    </div>
    <div v-else style="text-align: center;">
      <p class="request-name">{{lang[29]}}</p>
      <router-link :to="{ name: 'account.address', params: {name: $store.state.account.name } }">
        <btn type="primary" size="normal" :label="lang[30]"></btn>
      </router-link>
    </div>
  </modal>

 <modal v-if="isIdeaCheck" @close="close">
    <div class="check-preview-wrapper">
      <div class="check-preview"
        v-if="modalVal.img1"
        @click="previewModal=true,modalImg=modalVal.img1">
          <img :src="modalVal.img1">
      </div>
      <div class="check-preview"
        v-if="modalVal.img2"
        @click="previewModal=true,modalImg=modalVal.img2">
          <img :src="modalVal.img2">
      </div>
      <div class="check-preview"
        v-if="modalVal.img3"
        @click="previewModal=true,modalImg=modalVal.img3">
          <img :src="modalVal.img3">
      </div>
      <div class="check-preview"
        v-if="modalVal.img4"
        @click="previewModal=true,modalImg=modalVal.img4">
          <img :src="modalVal.img4">
      </div>
      <div class="check-preview"
        v-if="modalVal.img5"
        @click="previewModal=true,modalImg=modalVal.img5">
          <img :src="modalVal.img5">
      </div>
    </div>
    <p class="detail-title">{{lang[15]}}</p>
    <router-link :to="{ name: 'account.index', params: {name: modalUser.name } }">
      <div class="user">
        <div class="icon" v-if="modalUser.icon_img" :style="`background-image: url(${modalUser.icon_img})`"></div>
        <div class="icon" v-else></div>
        <div class="user-info">
          <p class="user-id">@{{ modalUser.name }}</p>
          <p class="user-name">{{ modalUser.screen_name }}</p>
        </div>
      </div>
    </router-link>
    <p class="idea-title">{{lang[4]}}</p>
    <p class="idea-text">{{ modalVal.price }}{{lang[6]}} + {{lang[5]}} {{request.tips}}{{lang[6]}}</p>
    <span v-if="$store.state.account.id === request.buyer_id">
      <p class="idea-title">{{lang[36]}}</p>
      <p class="idea-text">
        {{ Math.floor((modalVal.price + request.tips) * 1.036) }} {{lang[6]}}
      </p>
    </span>
    <p class="idea-title">{{lang[10]}}</p>
    <p class="idea-text">{{ modalVal.state? lang[24] : lang[23]}}</p>
    <p class="idea-title" v-if="modalVal.message">{{lang[11]}}</p>
    <p class="idea-text" v-if="modalVal.message">{{ modalVal.message}}</p>
    <div class="text-center" v-if="request.User.id == $store.state.account.id">
      <btn type="primary" size="normal" :label="lang[43]" @click="confirm=true"></btn>
    </div>
  </modal>
  <modal v-if="confirm" @close="close">
      <p class="text-center detail-title">{{lang[17]}}</p>
      <p class="text-center detail-text">{{lang[31]}}</p>
    <div class="m-t-20 text-center space-around">
      <btn type="cancel" size="normal" :label="lang[41]" @click="close()"></btn>
      <btn type="primary" size="normal" :label="lang[43]" @click="acceptIdea(modalVal.id, modalVal.saler_id, modalVal.price)" :loading="loading"></btn>
    </div>
  </modal>

  <modal v-if="isEvaluation">
    <p class="detail-title text-center">{{lang[32]}}</p>
    <div v-if="request.User.id == $store.state.account.id">
      <div class="user">
        <div class="icon" v-if="decideUser.icon_img" :style="`background-image: url(${decideUser.icon_img})`"></div>
        <div class="icon" v-else></div>
        <div class="user-info">
          <p class="user-id">@{{ decideUser.name }}</p>
          <p class="user-name">{{ decideUser.screen_name }}</p>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="user">
        <div class="icon" v-if="request.User.icon_img" :style="`background-image: url(${request.User.icon_img})`"></div>
        <div class="icon" v-else></div>
        <div class="user-info">
          <p class="user-id">@{{ request.User.name }}</p>
          <p class="user-name">{{ request.User.screen_name }}</p>
        </div>
      </div>
    </div>
    <div class="select-wrapper text-center" style="width: 80%;margin: auto;">
      <n-select
        v-model="evaluation.evaluations"
        class="select m-t-20"
        :placeholder="lang[33]"
        :options="[{label:'☆', value:1}, {label:'☆☆', value:2}, {label:'☆☆☆', value:3}, {label:'☆☆☆☆', value:4}, {label:'☆☆☆☆☆', value:5}, ]"
      >
      </n-select>
    </div>
    <textarea v-model="evaluation.message" class="textarea m-t-20" :placeholder="lang[34]"></textarea>
    <div class="text-center">
      <btn v-if="evaluation.evaluations" size="normal" type="primary" :label="lang[46]" @click="sendEvaluation" :loading="loading"></btn>
      <btn v-else size="normal" type="cancel" :label="lang[46]" v-if=""></btn>
    </div>
  </modal>

<!-- 画像の拡大 -->
  <modal v-if="previewModal" @close="close">
    <img :src="modalImg" class="modal-img">
  </modal>
  <app-menu v-if="this.$store.state.auth.authenticated"></app-menu>
  <notice v-if="isNotice" :title="noticeTitle" :text="noticeText" :type="noticeType"></notice>

  <modal v-if="isStripeModal" @close="close">
    <stripe-payment api="request" :item="decideVal" :request="request" @complete="complete"></stripe-payment>
  </modal>
</div>
</template>

<script>

import axios from 'axios'
import AppMenu from '../../components/Menu.vue'
import AppTitle from '../../components/Title.vue'
import Btn from '../../components/Button.vue'
import Modal from '../../components/Modal.vue'
import Notice from '../../components/Notice.vue'
import ReqPhase0 from '../../components/RequestPhase0.vue'
import ReqPhase1 from '../../components/RequestPhase1.vue'
import ReqPhase5 from '../../components/RequestPhase5.vue'
import SalPhase0 from '../../components/SalerPhase0.vue'
import SalPhase1 from '../../components/SalerPhase1.vue'
import SalPhase4 from '../../components/SalerPhase4.vue'
import SalPhase5 from '../../components/SalerPhase5.vue'
import DeleteReq from '../../components/DeleteRequest.vue'
import Message from '../../components/Message.vue'
import StripePayment from '../../components/StripePayment.vue'
import Loading from '../../components/Loading.vue'
import RequestDetailLangMaster from '../../masters/langMaster/RequestDetailLangMaster'
import NInput from '../../components/Input.vue'
import NSelect from '../../components/Select.vue'
import errHandling from '../../mixins/apiErrorHandle.js'
import langCheck from '../../mixins/langCheck.js'
import ogpSet from '../../mixins/ogpSet.js'
import tweet from '../../mixins/tweet.js'

export default {
  name: 'RequestDetail',

  components: {
    AppTitle,
    AppMenu,
    Btn,
    Modal,
    Notice,
    ReqPhase0,
    ReqPhase1,
    ReqPhase5,
    SalPhase0,
    SalPhase1,
    SalPhase4,
    SalPhase5,
    DeleteReq,
    Message,
    StripePayment,
    NInput,
    NSelect,
    Loading,
  },

  data() {
    return {
      lang: [],
      noAuthLang: '',
      isLoading: true,
      request: {},
      idea: {},
      evaluation: {},
      isPurchase: false,
      isSendIdea: false,
      isSend: false,
      isIdeaCheck: false,
      confirm: false,
      confirmShipped: false,
      isEvaluation: false,
      recieved: false,
      cameraImg: 'https://s3.amazonaws.com/nerzex-img-store/20197191123149def-camera.png',
      noticeTitle: '',
      noticeText: '',
      noticeType: '',
      isNotice: false,
      modalUser: {},
      modalVal: {},
      decideVal: {},
      decideUser: {},
      loading: false,
      requestPreview: '',
      previewModal: false,
      modalImg: '',
      isStripeModal: false,
      isAnime: false,
      contentTitle: '',
      animeId: Number,
      charaId: [],
      charaName: [],
      charaLength: 0,
      img1Validate: '',
      priceValidate: '',
      weight: '',
      shippingFee: 0,
      stateValidate: '',
      messageValidate: '',
    };
  },

  mixins: [errHandling, langCheck, ogpSet, tweet],

  created() {
    this.getRequest()
    this.langCheck(RequestDetailLangMaster)
  },

  watch: {
    weight() {
      axios.get(`private/shipping/${this.request.User.id}/${this.weight}`)
      .then( data => {
      })
    }
  },

  methods: {
    getRequest() {
      this.loading = true
      axios.get(`public/request/${this.$route.params.id}`)
      .then((data) => {
        this.request = data.data.model
        this.ogpSet(this.request.name, this.request.img1)
        this.initialize()
        this.requestPreview = this.request.img1
        this.loading = false
      }).catch((err) => {
      });
      let recaptchaScript = document.createElement('script')
      recaptchaScript.setAttribute('src', 'https://js.stripe.com/v3/')
      document.head.appendChild(recaptchaScript)
    },

    initialize() {
      this.translateTags()
      this.getDecideData()
      this.checkEvaluation()
    },

    sendIdea() {
      this.loading = true
      const postData = this.idea
      postData.saler_id = this.$store.state.account.id
      postData.request_id = Number(this.$route.params.id)
      postData.buyer_id = this.request.User.id
      axios.post('private/idea', postData)
      .then((data) => {
        this.noticeType = 'success'
        this.noticeTitle = 'success!'
        this.noticeText = 'Your idea was sent!'
        this.isNotice = true
        this.isSendIdea = false
        this.request.Ideas.push(data.data.model)
        this.loading = false
      }).catch((err) => {
        this.errorHandling(err)
        this.noticeType = 'alert'
        this.noticeTitle = 'Error'
        this.noticeText = err.message
        this.isNotice = true
        this.loading = false
      })
    },

    //アイデアの承認
    acceptIdea(id, salerId) {
      this.loading = true
      const amount = Math.round((this.modalVal.price + (this.request.tips? this.request.tips : 0) * 1.036))
      axios.post('private/trade/accept_idea', {
        idea_id: id,
        saler_id: salerId,
        buyer_id: this.request.User.id,
        request_id: this.$route.params.id,
        type: 0,
        amount: amount,
        price: amount,
      }).then(data => {
        this.close()
        this.noticeType = 'success'
        this.noticeTitle = 'success!'
        this.noticeText = 'Accepted an idea!'
        this.isNotice = true
        this.request = {}
        this.getRequest()
      }).catch(data => {
        console.log(err)
      })
    },

    //アイテムの配送完了
    shipped(id, salerId) {
      axios.post('private/trade/send_request', {
        idea_id: id,
        saler_id: salerId,
        buyer_id: this.request.User.id,
        request_id: this.$route.params.id,
        type: 0,
      }).then(data => {
        this.close()
        this.noticeType = 'success'
        this.noticeTitle = 'success!'
        this.noticeText = "Thank you for shipping the item!Don't forget to share the tracking code to the buyer!"
        this.isNotice = true
        this.request = {}
        this.getRequest()
      }).catch(err => {
        this.loading = false
        console.log(err)
      })
    },

    requestDone() {
      axios.post('private/trade/request_done', {
        idea_id: this.decideVal[0].id,
        saler_id: this.decideVal[0].saler_id,
        buyer_id: this.request.User.id,
        request_id: this.$route.params.id,
        evaluation_id1: this.request.Evaluations[0].id,
        evaluation_id2: this.request.Evaluations[1].id,
        type: 0,
      }).then(data => {
        this.close()
        this.noticeType = 'success'
        this.noticeTitle = 'success!'
        this.noticeText = 'Thanks for evaluation!'
        this.notice = true
        this.request = {}
        this.getRequest()
      })
    },

    openPurchase() {
      this.isPurchase = true
    },

    close() {
      this.isPurchase = false
      this.isSendIdea = false
      this.isIdeaCheck = false
      this.confirm = false
      this.confirmShipped = false
      this.recieved = false
      this.isEvaluation = false
      this.previewModal = false
      this.isStripeModal = false
      setTimeout(this.isNotice = false ,5000)
    },

    nullCheckVal() {
      let checkArr = ['price','state','img1']
      for(let i=0, len=checkArr.length; i < len; i++) {
        if(!this.idea[checkArr[i]]) {
          this.isSend = false
          return false
        } else {
          this.isSend = true
        }
      }
    },

    selectedFile(e) {
      e.preventDefault();
      this.uploadFile = e.target.files[0];
      const uploadData = new FormData()
      uploadData.append('file', this.uploadFile)
      this.cameraImg = 'https://s3.amazonaws.com/nerzex-img-store/20197191132833282.gif'
      axios.post('private/aws/s3up', uploadData)
      .then((data) => {
        this.idea[e.target.id] = data.data.name
        this.nullCheckVal()
        this.cameraImg = 'https://s3.amazonaws.com/nerzex-img-store/20197191123149def-camera.png'
        this.loading = false
      }).catch((err) => {
        this.cameraImg = 'https://s3.amazonaws.com/nerzex-img-store/20197191123149def-camera.png'
        this.loading = false
      });
    },

    ideaModal(val) {
      this.loading = true
      axios.get(`public/user_id/${val.saler_id}`)
      .then((data) => {
        this.isIdeaCheck = true
        this.modalVal = val
        this.modalUser = data.data.user
        this.loading = false
      }).catch((err) => {
        this.loading = false
      })
    },

    async getDecideData() {
      this.isLoading = true
      if(this.request.Trades[this.request.Trades.length -1].phase >= 1) {
        this.decideVal = await this.request.Ideas.filter(arr =>
          arr.id === this.request.Trades[this.request.Trades.length -1].idea_id
        )
        await this.getDecideUser()
      } else {
        this.isLoading = false

      }
    },

    async getDecideUser() {
      await axios.get(`public/user_id/${this.decideVal[0].saler_id}`)
      .then((data) => {
        this.decideUser = data.data.user
        this.isLoading = false
        return this.decideUser
      }).catch((err) => {
        this.isLoading = false
        throw new Error(err)
        console.log(err)
      })
    },

    sendEvaluation(user_id, target_id) {
      this.loading = true
      axios.post('private/evaluation', {
        user_id: this.$store.state.account.id,
        target_id: this.request.User.id == this.$store.state.account.id ? this.decideVal[0].saler_id : this.request.User.id,
        request_id: this.request.id,
        evaluations: this.evaluation.evaluations,
        message: this.evaluation.message,
      }).then(data => {
        if(this.request.Evaluations.length >= 1) {
          this.request.Evaluations.push(data.data.model)
          this.requestDone()
        } else {
          this.close()
          this.noticeType = 'success'
          this.noticeTitle = 'success!'
          this.noticeText = "ζ*'ヮ')ζ＜ Thanks for evaluation!"
          this.isNotice = true
          this.getRequest()
        }
        this.loading = false
      }).catch(err => {
        this.loading = false
      })
    },

    checkEvaluation() {
      this.isLoading = true
      //誰も評価していない時
      if(this.request.Trades[this.request.Trades.length -1].phase === 6 &&
        this.request.Evaluations.length === 0) {
          //自分がリクエストしている、または自分がセラーの場合
          if(this.request.User.id === this.$store.state.account.id ||
            this.request.Trades[this.request.Trades.length -1].saler_id == this.$store.state.account.id) {
              this.isEvaluation = true
          }
      //相手が評価しているけど自分が評価していない場合
      } else if(this.request.Trades[this.request.Trades.length -1].phase === 6 &&
        this.request.Evaluations.length === 1 &&
        this.request.Evaluations[0].target_id === this.$store.state.account.id
      ) {
        this.isEvaluation = true
      }
      this.isLoading = false
    },

    complete() {
      this.close()
      this.noticeType = 'success'
      this.noticeTitle = 'payment success!'
      this.noticeText = 'payment success!'
      this.isNotice = true
      this.getRequest()
    },

    recieve() {
      this.close()
      this.noticeType = 'success'
      this.noticeTitle = 'success!'
      this.noticeText = 'Have a nice otaku life! Please evaluation for proposer'
      this.isNotice = true
      this.getRequest()
    },

    async translateTags() {
      const tagArray = ['maker', 'character', 'item_category']
      await Promise.all(tagArray.map(async (tag) => {
        if(!isNaN(this.request[tag]) && this.request[tag] !== null && tag !== 'character') {
          await this.getValue(this.request[tag], tag).then(data => {
            this.request[`tag${tag}`] = data
          })
        } else if(tag === 'character') {
          this.charaId = this.request.character
          this.charaName = this.charaId.filter(chara => {
            this.getValue(chara, tag).then(data => {
              this.charaName.push(data)
              return data
            })
          })
        }
      })).then(data => {
        this.isLoading = false
      }).catch(err => {
        console.log(err)
      })
    },

    async getValue(val, api) {
      const getValueData = await axios.get(`public/${api}/tag/${val}`).then(data => {
        if(data.data.result && api == 'character') {
          if(data.data.result.ContentTitle !== null) {
            this.getValue(data.data.result.anime_id, 'content_title')
            this.isAnime = true
            this.animeId = data.data.result.anime_id
            return this.tagLangFilter(data.data.result)
          }
        } else if (data.data.result && api == 'content_title') {
          this.contentTitle = this.tagLangFilter(data.data.result)
        }
        return this.tagLangFilter(data.data.result)
      }).catch(err => {
        return false
      })
      return getValueData
    },

    tagLangFilter(val) {
      //優先度の高い言語順の配列作成(重複しても問題ない)
      let priorityArr = []
      if(this.$store.state.account.lang) {
        priorityArr = [this.$store.state.account.lang, 'ja', 'en']
      } else {
        priorityArr = [this.noAuthLang, 'ja', 'en']
      }
      let tag =''
      for (let i = 0; i<3; i++) {
        if(val[priorityArr[i]] !== null) {
          tag = val[priorityArr[i]]
          break
        }
      }
      return tag
    },

    checkAddress() {
      let checkArr = []
      if(this.$store.state.account.country === "Japan") {
        checkArr = ['address_kanji','post_code','country', 'prefecture_kanji', 'street_kanji', 'line1_kanji', 'first_name_kanji', 'last_name_kanji']
      } else {
        checkArr = ['address','post_code', 'country', 'prefecture', 'street', 'line1', 'first_name', 'last_name']
      }

      for(let i=0, len=checkArr.length; i < len; i++) {
        if(!this.$store.state.account[checkArr[i]]) {
          return false
        }
      }
      return true
    },

    searchShippingFee() {
      axios.get(`/private/shipping/${this.request.User.id}/${this.weight}`)
      .then(data => {
      }).catch(err => {
        console.log(err)
      })
    },

    register(url) {
      localStorage.setItem('nerzex.appState.registerSource', url)
      this.$router.push('/register')
    },
  }
}

</script>

<style scoped>

.request-detail {
  margin-bottom: 70px;
}
.preview {
  /*width: 100vw;*/
  height: 50vh;
  margin: 0;
  background: white;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;padding: 0;
  transition: 0.7s ease;
  position: relative;
  overflow: hidden;
}

.preview:hover {
  cursor: pointer;
  cursor: hand;
  box-shadow: 0px 0px 9px #f39939;
}

.preview img {
  width: fit-content;
}

.sub-preview-wrapper, .check-preview-wrapper{
  display: -webkit-box;
  display: -ms-flexbox;
  overflow-x: auto;
}

.sub-preview {
  width: 100px;
  height: 100px;
  margin: 10px;
  background: #000;
  background-size: cover;
  background-position: center;
  margin: 0;
}

.check-preview {
width: 100px;
height: 100px;
margin: 10px;
text-align:center;
}

.sub-preview img, .check-preview img {
  width: inherit;
  height: inherit;
}

.request-title {
  font-size: 20px;
}

.request-name {
 font-size: 18px;
 font-weight: bold;
 margin-bottom:0px !important ;
}


.detail-title {
  margin-top: 25px;
}

.detail-text{
  font-size: 14px;
}

.request-wrapper {
  padding: 25px;
  max-width: 1200px;
  margin: 0 auto;
}

.request-wrapper a {
  text-decoration: none;
}

.user {
  display: flex;
  margin-bottom: 20px;
}

.icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid #F39939;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-image: url('../../assets/img/def-user.png');
}

.user-info {
  margin: auto 10px;
}

.user-id {
  margin-bottom: 5px !important;
  font-size: 12px;
}

.user-name {
  margin: 0;
  font-size: 16px;
}

.btn-wrapper {
  margin-top: 40px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.btn-wrapper > div {
  margin-top: 10px;
}

.modal-img {
  max-width: 50vw;
  height: 30vh;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin: 0 auto;
}

.p-20 {
  padding: 20px;
}

.img-area {
  display: flex;
  overflow-x: scroll;
  margin-top: 20px;
}

.request-img-wrapper {
  width: 100px;
  height: 100px;
  margin: 10px;
}

.request-img {
  width: 100px;
  height: 100px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.sub-preview img {
  width: inherit;
  height: inherit;
}


.idea-wrapper {
  margin: 20px;
  border-radius: 10px;
  background: #F39939;
  padding: 10px;
  color: #fff;
}

.idea-wrapper p {
  margin-bottom: 0.4rem;
}
.m-t-20 {
  margin-top: 20px;
}

input[type='file'] {
  display: none;
}

a {
  color: #212529;
}

.space-around {
  justify-content: space-around;
  display: flex;
}

.textarea {
  padding: 5px;
  border: 1px solid #707070;
  border-radius: 5px;
  width: 80vw;
  height: 100px;
  background: #fff;
  margin: 20px auto;
}

.complate-img {
  width: 200px;
  height: auto;
}

.modal-img {
  object-fit: contain;
  width: 100%;
  max-width: 800px;
}

.tag-wrapper{
  display: flex;
  justify-content:
}

.tag{
  padding: 5px;
  margin: 5px;
  color: #f39939;
  border-radius: 5px;
  font-size: 14px;
  border: 1px solid;
}

.item-maker-lavel {
  background-color: #f3983b;
  width: 80px;
  color: white;
  text-align: center;
  border-radius: 5px;
  margin: 0 0 5px 0 !important;
}

.item-character-lavel {
  background-color: #f3983b;
  width: 120px;
  color: white;
  text-align: center;
  border-radius: 5px;
  margin: 0 0 5px 0 !important;
}

.item-price-lavel {
  background-color: #f3983b;
  width: 55px;
  color: white;
  text-align: center;
  border-radius: 5px;
  margin: 0 0 5px 0 !important;
}

.item-delivery-lavel {
  background-color: #f3983b;
  width: 70px;
  color: white;
  text-align: center;
  border-radius: 5px;
  margin: 0 0 5px 0 !important;
}

.item-state-lavel {
  background-color: #f3983b;
  width: 55px;
  color: white;
  text-align: center;
  border-radius: 5px;
  margin: 0 0 5px 0 !important;
}

.mb-30 {
  margin-bottom: 30px;
}

.delivery-and-state {
  display: flex;
}

.request-info {
  padding: 25px;
}

.idea-title {
  font-size: 18px;
  margin: 0;
  font-weight: bold;
  mergin-left: 10px;
}

.stripe-fee-text {
  font-size: 14px;
  margin: 15px 5px;
}

.sold {
    top: 9%;
    left: -18%;
}

.share-button {
  margin: 10px;
}

.share-button img {
  width: 120px;
  height: auto;
}

@media screen and (min-width: 800px){
  .request-name {
    font-size: 20px;
  }

  .detail-title {
    font-size: 18px;
  }

  .detail-text {
    font-size: 18px;
  }

  .textarea {
    width: 80%;
  }

  .preview-box {
    width: 50%;
    margin: 0 0 0 auto;
  }

  .request-main {
    display: flex;
    max-width: 1200px;
    margin: 80px auto;
  }

  .request-info {
    width: 35%;
    margin: 0 0 0 80px;
    padding: 0px;
  }

  .sub-preview {
    margin: 0px;
    background: #000;
    width: 100px;
    height: 100px;
    background-size: cover;
    background-position: center;
  }

  .request-title {
    font-size: 25px;
    font-weight: 300;
  }

  .request-price {
    font-size: 30px;
    font-weight: 300;
    margin: 0 !important;
  }

  .request-tag-lavel {
    margin-bottom: 0 !important;
  }

  .request-info-item {
    margin-bottom: 10px;
  }

  .gray-tag {
    padding: 5px;
    margin: 5px;
    color: gray;
    border-radius: 5px;
    font-size: 14px;
    border: 1px solid;
  }

  .icon {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    border: 2px solid #F39939;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-image: url('../../assets/img/def-user.png');
  }

  .request-user-name {
    font-size: 20px;
    margin: 0 0 10px 0 !important;
    color: #F39939;
  }

  .user-id {
    font-size: 18px;
  }

  .user-info {
    margin: 40px 0 0 15px;
  }

  .user-name {
    font-size: 20px;
    margin: 0 !important;
  }

  .user {
    margin: 0 0 5px 0 !important;
  }

  .request-user-info {
    margin-bottom: 30px;
  }

  .request-message-title {
    font-size: 18px;
  }

  .sub-preview {
    width: 100px;
    height: 100px;
    background-position: center;
    transition: 0.7s ease;
    margin: 0 10px;
  }

  .sub-preview:first-child {
    margin: 0 10px 0 0;
  }

  .sub-preview:hover {
    box-shadow: 0px 0px 0px 2px #f39939;
    cursor: pointer;
    cursor: hand;
    transform: scale(0.95);
    border-radius: 10px;
  }

  .preview {
    margin-bottom: 20px;
  }

  .sold {
    top: 9%;
    left: -18%;
  }

  .share-button {
    margin: 10px 10px 10px 0px;
  }

  .share-button img {
    width: 180px;
    height: auto;
  }

}

</style>
